const STORAGE_KEY = 'solvetax_post_submit_guest';

export function firstNameFromFullName(name) {
  const trimmed = String(name || '').trim();
  if (!trimmed) return '';
  return trimmed.split(/\s+/)[0];
}

export function savePostSubmitGuestName(name) {
  const first = firstNameFromFullName(name);
  if (!first || typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.setItem(STORAGE_KEY, first);
  } catch {
    /* ignore quota / private mode */
  }
}

export function readPostSubmitGuestName() {
  if (typeof sessionStorage === 'undefined') return '';
  try {
    return sessionStorage.getItem(STORAGE_KEY) || '';
  } catch {
    return '';
  }
}

export function goToPostSubmit(navigate, name) {
  savePostSubmitGuestName(name);
  navigate('/post-submit');
}
